import React from "react";
import CatalogoPageLayout from "./CatalogoPageLayout";

const CatalogoListasPrecioPage: React.FC = () => (
  <CatalogoPageLayout
    title="Listas de precios"
    description="Generá y controlá múltiples listas de precios por marca, sucursal o canal de venta."
    helperText="Desde acá vas a definir vigencias, monedas y reglas de actualización de precios."
  />
);

export default CatalogoListasPrecioPage;
